import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  RemoveEstimateLineItemMutation as RemoveEstimateLineItemMutationResult,
  Scalars,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const RemoveEstimateLineItemMutation = graphql(`
  mutation RemoveEstimateLineItem($id: ID!) {
    removeEstimateLineItem(id: $id) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
        pendingSolarLayoutImage
      }
    }
  }
`);

type Variables = {
  id: Scalars['ID']['input'];
};

const useRemoveEstimateLineItem = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    RemoveEstimateLineItemMutationResult,
    Error,
    Variables
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<RemoveEstimateLineItemMutationResult, Error, Variables>({
    mutationFn: ({ id }) => {
      return gqlClient.request(RemoveEstimateLineItemMutation, { id });
    },
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.removeEstimateLineItem,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useRemoveEstimateLineItem;
